import { SpelExpressionEvaluator } from 'spel2js';

import { ExpEvalRequest, ExpEvalResult, ExpService } from '../api';
import { createContext } from './spelUtils';

class SpELExpService implements ExpService {
  evaluate = (request: ExpEvalRequest): ExpEvalResult => {
    const { expression, data } = request;
    const context = createContext();
    const variables = request.variables ? request.variables : {};
    Object.keys(variables).forEach((key) => (context[key] = variables[key]));
    const value = SpelExpressionEvaluator.eval(expression, data, context);
    return {
      value: value,
    };
  };
}

const spelService = new SpELExpService();

export default spelService;
